"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var button_1 = tslib_1.__importDefault(require("./button/button"));
var nav_scss_1 = tslib_1.__importDefault(require("./nav.scss"));
var Nav = /** @class */ (function (_super) {
    tslib_1.__extends(Nav, _super);
    function Nav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleNextClick = function () {
            var _a = _this.props, isDisabled = _a.isDisabled, onNextClick = _a.onNextClick;
            if (isDisabled) {
                return;
            }
            onNextClick();
        };
        _this.handlePrevClick = function () {
            var _a = _this.props, isDisabled = _a.isDisabled, onPrevClick = _a.onPrevClick;
            if (isDisabled) {
                return;
            }
            onPrevClick();
        };
        return _this;
    }
    Nav.prototype.renderPrevButton = function () {
        var _a;
        var _b = this.props, nextButtonClassName = _b.nextButtonClassName, prevButtonClassName = _b.prevButtonClassName, prevButtonAriaLabel = _b.prevButtonAriaLabel, customArrowIcon = _b.customArrowIcon, isRTL = _b.isRTL;
        var classNames = (0, classnames_1.default)((_a = {},
            _a[nextButtonClassName] = isRTL,
            _a[prevButtonClassName] = !isRTL,
            _a[nav_scss_1.default.arrowRight] = isRTL,
            _a[nav_scss_1.default.arrowLeft] = !isRTL,
            _a));
        return (react_1.default.createElement(button_1.default, { onClick: this.handlePrevClick, className: classNames, ariaLabel: prevButtonAriaLabel, dataHook: "prev-button", arrowIcon: customArrowIcon }));
    };
    Nav.prototype.renderNextButton = function () {
        var _a;
        var _b = this.props, nextButtonClassName = _b.nextButtonClassName, prevButtonClassName = _b.prevButtonClassName, nextButtonAriaLabel = _b.nextButtonAriaLabel, customArrowIcon = _b.customArrowIcon, isRTL = _b.isRTL;
        var classNames = (0, classnames_1.default)((_a = {},
            _a[nextButtonClassName] = !isRTL,
            _a[prevButtonClassName] = isRTL,
            _a[nav_scss_1.default.arrowRight] = !isRTL,
            _a[nav_scss_1.default.arrowLeft] = isRTL,
            _a));
        return (react_1.default.createElement(button_1.default, { onClick: this.handleNextClick, className: classNames, ariaLabel: nextButtonAriaLabel, dataHook: "next-button", arrowIcon: customArrowIcon }));
    };
    Nav.prototype.render = function () {
        var _a = this.props, isPrevVisible = _a.isPrevVisible, isNextVisible = _a.isNextVisible, className = _a.className, dataHook = _a.dataHook;
        return (react_1.default.createElement("nav", { className: className, "data-hook": dataHook },
            isPrevVisible && this.renderPrevButton(),
            isNextVisible && this.renderNextButton()));
    };
    return Nav;
}(react_1.default.Component));
exports.default = Nav;
//# sourceMappingURL=nav.js.map